const types = {
    GET_ENTITY_LIST_START : "GET_ENTITY_LIST_START",
    GET_ENTITY_LIST_SUCCESS: "GET_ENTITY_LIST_SUCCESS",
    GET_ENTITY_LIST_ERROR: "GET_ENTITY_LIST_ERROR",

    GET_ENTITY_BY_ID_START: "GET_ENTITY_BY_ID_START",
    GET_ENTITY_BY_ID_SUCCESS: "GET_ENTITY_BY_ID_SUCCESS",
    GET_ENTITY_BY_ID_ERROR: "GET_ENTITY_BY_ID_ERROR",

    ADD_RULE_FOR_ENTITY_START: "ADD_RULE_FOR_ENTITY_START",
    ADD_RULE_FOR_ENTITY_SUCCESS: "ADD_RULE_FOR_ENTITY_SUCCESS",
    ADD_RULE_FOR_ENTITY_ERROR: "ADD_RULE_FOR_ENTITY_ERROR",

    UPDATE_RULE_FOR_ENTITY_START: "UPDATE_RULE_FOR_ENTITY_START",
    UPDATE_RULE_FOR_ENTITY_SUCCESS: "UPDATE_RULE_FOR_ENTITY_SUCCESS",
    UPDATE_RULE_FOR_ENTITY_ERROR: "UPDATE_RULE_FOR_ENTITY_ERROR",
}


export default types;